export default __webpack_public_path__ + "static/media/arblockbot-poster.5ec82da5.pdf";